import {  createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface AuthState {
    token: string | null;
    idRol: number | null;
}

const initialState: AuthState = {
    idRol: null,
    token: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        updToken: (state, action) => {
            state.token = action.payload;
        },
        updAuth: (state, action) => {
            const { token, idRol } = action.payload;
            state.token = token || null;
            state.idRol = typeof idRol === 'string' ? parseInt(idRol) : idRol || null;
        },
        logout: () => initialState,
    },
});

export const { updAuth, logout, updToken } = authSlice.actions;

export const selectRol = (state: RootState) => state.auth.idRol;
export const selectToken = (state: RootState) => state.auth.token;


export default authSlice.reducer;